.geoConfigHeader {
  grid-column: 1/3;
  grid-row: 1;
  height: 64px;
  padding: 24px 48px;
}
